module.exports = __webpack_public_path__ + "media/src/images/fabian-ff85e6eb46349dc3af52274d738a4884.jpg";